import { useReactToPrint } from "react-to-print";
import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import BillingServices from "../../services/BillingServices";
import useAsync from "../../hooks/useAsync";

const Customerinvoice = () => {
  const { id } = useParams();
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const { data: bill, loading } = useAsync(() => {
    const fetchBillDetails = async () => {
      if (!id) {
        return null;
      }
      const response = await BillingServices.getBillingById(id);
      return response;
    };
    return fetchBillDetails();
  }, [id]);

  if (loading || !bill) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="container mt-4">
        <div className="card" ref={contentRef}>
          <div className="card-body">
            <div className="row justify-content-between align-items-center border-bottom mb-3">
              <div className="col-md-6">
                <div className="mb-2">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    className="printer-logo"
                    alt="logo"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-end mb-3">
                  <h5 className="text-gray mb-1">
                    Invoice No{" "}
                    <span className="text-primary">#{bill.billNumber}</span>
                  </h5>
                  <p className="mb-1 fw-medium">
                    Created Date:{" "}
                    <span className="text-dark">
                      {new Date(bill.createdAt).toLocaleDateString()}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="row border-bottom mb-3">
              <div className="col-md-5">
                <h4 className="mb-1">Style Buzz Pro</h4>
                <p className="mb-1">Bangalore Karnataka India</p>
                <p className="mb-1">
                  <span className="text-dark fw-mediumk">Website: </span>
                  <span className="text-dark fw-mediumk">stylebuzzpro.com</span>
                </p>
                <p>
                  <span className="text-dark fw-medium">GSTIN: </span>
                  <span className="text-dark fw-medium">29AACFZ5858M1ZB</span>
                </p>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-3">
                <div className="mb-3">
                  <div>
                    <h4 className="mb-1">Invoice For</h4>
                    <p className="mb-1">
                      <span className="text-dark fw-medium">
                        Customer Name:{" "}
                      </span>
                      <span className="text-dark fw-medium">
                        {bill.customer.name}
                      </span>
                    </p>
                    <p>
                      <span className="text-dark fw-medium">
                        Customer Number:{" "}
                      </span>
                      <span className="text-dark fw-medium">
                        {bill.customer.phone}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className="fw-medium">
                Invoice For:{" "}
                <span className="text-dark fw-medium">Services</span>
              </p>
              <div className="table-responsive mb-3">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>Services</th>
                      <th className="text-end">Gross Amount</th>
                      <th className="text-end">Qty</th>
                      <th className="text-end">Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bill.services.map((service, index) => (
                      <tr key={index}>
                        <td>
                          <h6>{service.service.name}</h6>
                        </td>
                        <td className="text-gray-9 fw-medium text-end">
                          ₹{service.price.toFixed(2)}
                        </td>
                        <td className="text-gray-9 fw-medium text-end">
                          {service.quantity}
                        </td>
                        <td className="text-gray-9 fw-medium text-end">
                          ₹{(service.price * service.quantity).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row border-bottom mb-3">
              <div className="col-md-5 ms-auto mb-3">
                <div className="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3">
                  <p className="mb-0">Gross Total</p>
                  <p className="text-dark fw-medium mb-2">
                    ₹{bill.grossTotal.toFixed(2)}
                  </p>
                </div>
                {bill.store?.gstAvailable && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2 pe-3">
                      <p className="mb-0">CGST(2.5%)</p>
                      <p className="text-dark fw-medium mb-2">
                        ₹{bill.cgstAmount.toFixed(2)}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2 pe-3">
                      <p className="mb-0">SGST(2.5%)</p>
                      <p className="text-dark fw-medium mb-2">
                        ₹{bill.sgstAmount.toFixed(2)}
                      </p>
                    </div>
                  </>
                )}
                <div className="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3">
                  <p className="mb-0">Net Total</p>
                  <p className="text-dark fw-medium mb-2">
                    ₹{bill.afterDiscount.toFixed(2)}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3">
                  <p className="mb-0">Discount</p>
                  <p className="text-dark fw-medium mb-2">
                    ₹{bill.discount.toFixed(2)}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2 pe-3">
                  <h5>Grand Total Amount</h5>
                  <h5>₹{bill.netPayable.toFixed(2)}</h5>
                </div>
              </div>
            </div>
            <div className="payment-status-section p-2 bg-light rounded mt-3">
              <div className="row g-0">
                <div className="col-md-6">
                  <div className="payment-info p-2 border-end">
                    <div className="d-flex align-items-center mb-2">
                      <i className="ti ti-cash fs-5 text-primary me-2"></i>
                      <h6 className="mb-0 text-primary">Payment Methods</h6>
                    </div>
                    <div className="payment-methods-list">
                      {bill.payments && bill.payments.length > 0 ? (
                        bill.payments.map((payment, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-1 px-2 py-1 bg-white rounded"
                          >
                            <span className="text-capitalize small">
                              <i
                                className={`ti ti-${
                                  payment.mode === "card"
                                    ? "credit-card"
                                    : payment.mode === "upi"
                                    ? "qrcode"
                                    : "cash"
                                } me-1 text-primary`}
                              ></i>
                              {payment.mode.toUpperCase()}
                            </span>
                            <strong className="text-dark small">
                              ₹{payment.amount.toFixed(2)}
                            </strong>
                          </div>
                        ))
                      ) : (
                        <div className="px-2 py-1 bg-white rounded text-center">
                          <span className="text-muted small">
                            No payment information
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="status-info p-2">
                    <div className="d-flex align-items-center mb-2">
                      <i
                        className={`ti ti-${
                          bill.status === "paid"
                            ? "circle-check"
                            : bill.status === "pending"
                            ? "clock"
                            : "x-circle"
                        } fs-5 me-2 ${
                          bill.status === "paid"
                            ? "text-success"
                            : bill.status === "pending"
                            ? "text-warning"
                            : "text-danger"
                        }`}
                      ></i>
                      <h6 className="mb-0">Payment Status</h6>
                    </div>
                    <div className="status-display px-2 py-1 bg-white rounded text-center">
                      <h6
                        className={`mb-1 text-capitalize fw-bold ${
                          bill.status === "paid"
                            ? "text-success"
                            : bill.status === "pending"
                            ? "text-warning"
                            : "text-danger"
                        }`}
                      >
                        {bill.status}
                      </h6>
                      <p className="text-muted mb-0 small">
                        Total: <strong>₹{bill.netPayable.toFixed(2)}</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-4">
          <button
            onClick={() => reactToPrintFn()}
            className="btn btn-primary d-flex justify-content-center align-items-center me-2"
          >
            Download Invoice
            <i className="ti ti-download" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Customerinvoice;
